/**
 * Which edge geometry the CPA canvas draws, chosen once per page load from the URL.
 *
 *   ?mode=dev                 → the prototype's shapes (knowlegebase `program-tree-demo.html`):
 *                               question→question as S-curves, eligibility wires ending in curves,
 *                               pill-shaped rule labels
 *   anything else, or absent  → the production shapes: navigation keeps its right angles
 *                               (unchanged from before this switch existed), eligibility wires
 *                               are right-angled too, and only the rule→program fan-out curves
 *
 * In BOTH styles an eligibility wire is routed around the cards (see `ruleWirePath`): React
 * Flow paints nodes above edges, so a wire that crosses a card is not "drawn over it", it is
 * hidden under it and reads as a broken line. The switch only changes how the routed path is
 * drawn, never whether it is routed.
 *
 * Read like `?tree=shadow` (client/apiProvider.ts): straight off `window.location`, exact
 * match, never persisted — dropping the parameter and reloading always returns to production.
 */
export type LineStyle = 'dev' | 'default';

export function lineStyleFrom(search: string): LineStyle {
  return new URLSearchParams(search).get('mode') === 'dev' ? 'dev' : 'default';
}

export function currentLineStyle(): LineStyle {
  return typeof window === 'undefined' ? 'default' : lineStyleFrom(window.location.search);
}
